module.exports = __webpack_public_path__ + "img/Travel-Trailer-Mobile.83eb0fae.jpg";